import { useDatasetMappedIcon } from "hooks/useDatasetMappedIcon";
import { useDatasetMappedValue } from "hooks/useDatasetMappedValue";
import React from "react";

interface IColumnTabWithMapperProps {
  value: number | string;
  mapperId: number;
}
export default function ColumnTabWithMapper({ value, mapperId }: IColumnTabWithMapperProps) {
  const mappedValue = useDatasetMappedValue(value as number, mapperId);
  const mappedIcon = useDatasetMappedIcon(value as number, mapperId);

  if (mappedIcon) {
    return <i className={mappedIcon as string} />;
  }

  if (mappedValue) {
    return mappedValue;
  }
  return value;
}
